import * as types from "./auth.actionTypes";

let initialAuthStatus = JSON.parse(localStorage.getItem("isAuth")) || false;
const initialState = {
  isLoading: false,
  isError: false,
  isAuth: initialAuthStatus,
  token: localStorage.getItem("token") || "",
  user: JSON.parse(localStorage.getItem("user")) || {
    name: "Ripik Optimus Guest",
    email: "guest@ripik.in",
    role: "guest",
  },
  register: {
    isSuccessfull: false,
  },
  clientId: "ripik",
};

export const auth = (state = initialState, { type, payload }) => {
  switch (type) {
    case types.USER_REGISTER_REQUEST: {
      return {
        ...state,
        isLoading: true,
        isError: false,
        register: {
          ...state.register,
          isSuccessfull: false,
        },
      };
    }

    case types.USER_REGISTER_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        isError: false,
        register: {
          ...state.register,
          isSuccessfull: true,
        },
      };
    }

    case types.USER_LOGIN_REQUEST: {
      return { ...state, isLoading: true, isError: false };
    }

    case types.USER_LOGIN_SUCCESS: {
      // console.log(payload);
      // console.log(payload.user);
      localStorage.setItem("token", payload.auth_token);
      return {
        ...state,
        isLoading: false,
        isError: false,
        isAuth: true,
        token: payload.auth_token,
        user: payload.user,
      };
    }

    case types.USER_LOGIN_FAILED: {
      return { ...state, isLoading: false, isError: true, isAuth: false };
    }

    case types.USER_LOGOUT: {
      return {
        ...initialState,
        isAuth: false,
        user: {
          ...initialState.user,
          name: "Ripik Optimus Guest",
          email: "guest@ripik.in",
          role: "guest",
        },
      };
    }

    default: {
      return state;
    }
  }
};
